<template>
  <v-snackbar
    @input="closeSnackbar"
    :color="color"
    left
    v-model="computedIsVisible"
    :timeout="60000"
  >
    {{ message }}
    <v-btn dark text @click="closeSnackbar">
      Close
    </v-btn>
  </v-snackbar>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'Snackbar',
  computed: {
    computedIsVisible: {
      set(value) {
        this.value = value
      },
      get() {
        return this.isVisible
      }
    },
    ...mapGetters('snackbar', ['isVisible', 'message', 'color'])
  },
  methods: {
    ...mapMutations('snackbar', ['hideSnackbar']),
    closeSnackbar() {
      this.hideSnackbar()
    }
  }
}
</script>
